// extracted by mini-css-extract-plugin
module.exports = {"titleTextContainer":"LoadbeeModal_titleTextContainer__6mMCE","titleText":"LoadbeeModal_titleText__1t827","modalButtonContainer":"LoadbeeModal_modalButtonContainer__opIKM"};